import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Card, CardHeader, CardTitle, CardContent, CardFooter } from './styled/Card';
import { PrimaryButton } from './styled/Button';
import { Input, FormGroup, FormLabel, FormError } from './styled/Input';
import { Container, Main, Flex } from './styled/Layout';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const result = await login(email, password);
      if (result.success) {
        // Force page reload to trigger AuthContext initialization
        window.location.href = '/';
      } else {
        setError(result.error || 'Login failed');
      }
    } catch (error) {
      setError('An unexpected error occurred');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container>
      <Main style={{ justifyContent: 'center', alignItems: 'center' }}>
        <Card style={{ maxWidth: '400px', width: '100%' }}>
          <CardHeader>
            <Flex align="center" gap="var(--space-2)" style={{ marginBottom: 'var(--space-3)' }}>
              <span style={{ fontSize: '24px' }}>☁️</span>
              <CardTitle style={{ fontSize: 'var(--font-size-h1)', margin: 0 }}>
                {window.location.hostname.split('.')[0]}
              </CardTitle>
            </Flex>
            <h1 style={{ 
              fontSize: 'var(--font-size-h1)', 
              fontWeight: 'var(--font-weight-bold)', 
              color: 'var(--text-primary)',
              margin: '0 0 var(--space-2) 0'
            }}>
              Welcome Back
            </h1>
            <p style={{ 
              fontSize: 'var(--font-size-body)', 
              color: 'var(--text-secondary)',
              margin: 0
            }}>
              Sign in to your account
            </p>
          </CardHeader>

          <CardContent>
            <form onSubmit={handleSubmit}>
              {error && (
                <FormError style={{ marginBottom: 'var(--space-3)' }}>
                  {error}
                </FormError>
              )}

              <FormGroup>
                <FormLabel htmlFor="email">Email Address</FormLabel>
                <Input
                  type="email"
                  id="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  placeholder="Enter your email"
                />
              </FormGroup>

              <FormGroup>
                <FormLabel htmlFor="password">Password</FormLabel>
                <div style={{ position: 'relative' }}>
                  <Input
                    type={showPassword ? 'text' : 'password'}
                    id="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                    placeholder="Enter your password"
                    style={{ paddingRight: '45px' }}
                  />
                  <button
                    type="button"
                    onClick={() => setShowPassword(!showPassword)}
                    style={{
                      position: 'absolute',
                      right: '12px',
                      top: '50%',
                      transform: 'translateY(-50%)',
                      background: 'none',
                      border: 'none',
                      cursor: 'pointer',
                      padding: '4px 8px',
                      color: 'var(--text-secondary)',
                      fontSize: '18px',
                      lineHeight: '1',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}
                    title={showPassword ? 'Hide password' : 'Show password'}
                  >
                    {showPassword ? '👁️' : '👁️‍🗨️'}
                  </button>
                </div>
              </FormGroup>

              <PrimaryButton 
                type="submit" 
                style={{ width: '100%', marginTop: 'var(--space-3)' }}
                disabled={loading}
              >
                {loading ? 'Signing In...' : 'Sign In'}
              </PrimaryButton>
            </form>
          </CardContent>

          <CardFooter>
            <Flex direction="column" gap="var(--space-3)" style={{ width: '100%' }}>
              <p style={{ 
                fontSize: 'var(--font-size-body)', 
                color: 'var(--text-secondary)',
                margin: 0,
                textAlign: 'center'
              }}>
                Don't have an account? 
                <a 
                  href="/register" 
                  style={{ 
                    color: 'var(--text-link)', 
                    textDecoration: 'underline',
                    marginLeft: 'var(--space-1)'
                  }}
                > 
                  Sign up
                </a>
              </p>
              <div style={{ 
                padding: 'var(--space-3)', 
                backgroundColor: 'var(--ui-surface-alt)', 
                borderRadius: 'var(--border-radius-small)',
                border: '1px solid var(--ui-border)'
              }}>
                <p style={{ 
                  fontSize: 'var(--font-size-label)', 
                  fontWeight: 'var(--font-weight-semibold)', 
                  color: 'var(--text-primary)',
                  margin: '0 0 var(--space-1) 0'
                }}>
                  Demo Credentials:
                </p>
                <p style={{ 
                  fontSize: 'var(--font-size-fine)', 
                  color: 'var(--text-secondary)',
                  margin: '0 0 var(--space-1) 0'
                }}>
                  Email: demo@example.com
                </p>
                <p style={{ 
                  fontSize: 'var(--font-size-fine)', 
                  color: 'var(--text-secondary)',
                  margin: 0
                }}>
                  Password: Demo123!
                </p>
              </div>
            </Flex>
          </CardFooter>
        </Card>
      </Main>
    </Container>
  );
};

export default Login;
